//@flow
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import InlineLoader from '../../../../../../../../elements/LoadingSpinner/InlineLoader';

const useStyles = makeStyles(() => ({
  container: {
    width: '300px',
    height: '300px',
    borderRadius: '.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0',
    border: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    background: '#F4F4F6',
  },
}));

type Props = {
  coords: {
    lat: number,
    lng: number,
  },
  self?: boolean,
};

export default function MapMessage(props: Props) {
  const {coords} = props;
  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  const url = `https://maps.google.com/maps?q=${coords.lat},${coords.lng}`;

  const {lat, lng} = coords;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      className={classes.container}
    >
      {loading && <InlineLoader loading={loading} size={40} />}
      <iframe
        title={`Mapa de ${lat}, ${lng}`}
        width="300"
        height="300"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src={`https://maps.google.com/maps?q=${coords.lat},${coords.lng}&output=embed`}
        onLoad={() => setLoading(false)}
        style={{display: loading ? 'none' : 'block'}}
      />
    </a>
  );
}
